<template>
  <div class="content">
    <van-tabs
      @click="onClick"
      color="#ff6927"
      line-width="16"
      title-active-color="#ff6927"
      v-model="viewType"
    >
      <van-tab title="转发路径" name="tree">
        <div class="shareLink" id="shareLink">
          <v-chart :options="option" :initOptions="initOptions" @click="getMoreData($event)" />
        </div>
      </van-tab>
      <van-tab title="转发列表" name="list">
        <div class="topLine"></div>
        <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
          <van-list
            class="article_list"
            v-model="loading"
            :immediate-check="false"
            :finished="finished"
            finished-text="我也是有底线的~~~"
            @load="onLoad"
          >
            <div class="list_item" v-for="(item, idx) in personList" :key="idx">
              <div class="article_pic_wrap">
                <van-image
                  v-if="item.headimgurl"
                  height="42"
                  width="42"
                  :src="item.headimgurl"
                  error-icon
                />
                <img
                  v-if="!item.headimgurl"
                  height="42"
                  width="42"
                  src="./img/bin.png"
                  style="border-radius: 3px"
                />
              </div>
              <div class="van-multi-ellipsis--l2 article_title">
                <p>
                  <span v-if="item.insuredname || item.nickname == null" class="nameSpan">
                    {{
                    item.insuredname ? cutString(item.insuredname, 6) : "访客"
                    }}
                  </span>
                  <span
                    class="nameSpan"
                    v-if="item.nickname && item.insuredname"
                  >（{{ cutString(item.nickname, 6) }}）</span>
                  <span
                    class="nameSpan"
                    v-if="item.nickname && item.insuredname == null"
                  >{{ cutString(item.nickname, 6) }}</span>
                  <span class="statusSpan" v-if="item.insuredcode">
                    <img src="./img/build.png" alt style="margin-right: 3px" />已建档
                  </span>
                  <span class="statusSpan" v-else>
                    <img src="./img/none.png" alt /> 未建档
                  </span>
                </p>
              </div>
              <div class="clueNum">
                <div class="num">
                  <img src="./img/share.png" alt />
                  <div style="color: #646d79">转发&nbsp;{{ item.redCount }}</div>
                </div>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </van-tab>
    </van-tabs>
  </div>
</template>
<script>
import ECharts from "vue-echarts";
import echarts from "echarts";
import URL from "@/api/api";
export default {
  name: "shareLink",
  components: {
    "v-chart": ECharts,
  },
  data() {
    let categories = [];
    return {
      viewType: "tree",
      pageTitle: "转发链路",
      initOptions: {
        width: document.body.clientWidth,
        height: document.body.clientHeight,
      },
      option: {
        // title: {
        //   text: "知识图谱"
        // },
        legend: [
          {
            // selectedMode: 'single',
            show: false,
            data: categories.map((x) => x.name),
            icon: "circle",
          },
        ],
        series: [
          {
            type: "graph",
            layout: "force",
            symbolSize: 60,
            draggable: true,
            roam: false,
            symbol: "circle",
            focusNodeAdjacency: true,
            categories: categories,
            edgeSymbol: ["", "arrow"],
            edgeSymbolSize: [80, 10],
            edgeLabel: {
              normal: {
                show: false,
                textStyle: {
                  fontSize: 20,
                },
                formatter(x) {
                  return x.data.name;
                },
              },
            },
            itemStyle: {
              borderWidth: 30,
              borderType: "solid",
              borderColor: "#cacaca",
            },
            label: {
              normal: {
                show: true,
                position: "bottom",
                fontSize: 16,
                distance: 4,
                // backgroundColor: "#1048FF",
                lineHeight: 18,
                borderRadius: 25,
                color: "#717171",
                padding: [2, 6],
              },
            },

            lineStyle: {
              color: "#2A95FB",
              width: 2,
              type: "solid",

              // normal: {
              //   opacity: 0.9,
              //   width: 2,
              //   curveness: 0,
              //   globalCoord: false // 缺省为 false
              //   }
            },
            force: {
              repulsion: 1000,
              edgeLength: 35,
            },
            markPoint: {
              symbol: "pin",
              symbolSize: 30,
            },
            data: [
              {
                id: null,
                name: "他山石",
                symbol: "https://thirdwx.qlogo.cn/mmopen/vi_32/Hb86UZQtIUWJ35pmvlHfCDMTwY2McGLZthIT4PqSdBnDve9TQh5fNMTooVn4IBvMd3WXnFTOiagTQQU9DZMVy5w/132"
                , unionid: "oP22H5riFvhzEvkq4eKZLAWXiKkg"
              },
              {
                id: null,
                name: "秋水共长天一色",
                symbol: "https://thirdwx.qlogo.cn/mmopen/vi_32/DYAIOgq83erKFNFAQl3ibwr8A7LEdhxdqPicicJxsHwtAyP1e4hqWlk8X3NeFdTGsbvqsOPDUf2dzBiaDGmrrALtfw/132",
                unionid: "oP22H5vEgUlJajnMrPDOCht-Fr7Q"
              }
            ],
            links: [],
          },
        ],
        myChart: null,
        datas: [],
        unionidArr: null,
        lastUnionid: "",
        lastTarget: "",
        dataSize: "",
        allName: null,
        canClick: true,
      },
      tendsType: "",
      loading: false,
      finished: false,
      refreshing: false,
      pageNum: 1, //请求第几页
      pageSize: 10, //每页请求的数量
      total: 0, //总共的数据条数
      personList: [],
    };
  },
  created() {
    // this.option.series[0].data=this.shareData.nodes
    // this.option.series[0].links=this.shareData.links
  },
  mounted() {
    this.allName = [];
    this.unionidArr = [];
    this.canClick = true;
    this.getData();
    // document.getElementById("shareLink").addEventListener("touchmove", this.scrollFn, { passive: false }); //passive 参数不能省略，用来兼容ios和android
  },
  methods: {
    scrollFn(e) {
      e.preventDefault();
    },
    onClick(name, title) {
      if (this.viewType == "list") {
        this.pageNum = 1;
        this.getDataList();
      }
    },
    initChart() {
      // 注意 要写在 this.setOptions(this.chartData); 后面
      //解决指向问题
      let that = this;
      this.chart = echarts.init(this.$el);

      this.chart.setOption(this.option);
      // 把点击的数据传递给父组件，当然你也可以对数据做处理
    },
    getData() {
      let that = this;
      let data = {
        unionid: localStorage.getItem("unionid"),
        artcId: that.$route.query.activitie_id,
        lastUnionid: that.lastUnionid
          ? that.lastUnionid
          : localStorage.getItem("unionid"),
        target: that.lastTarget,
        size: that.dataSize,
        names: that.allName,
        unionids: [],
      };
      that.$fetchPost(URL.getTreeForward.url, data).then((res) => {
        if (res.data.code == "20000") {
          that.dataSize = res.data.data.links.length;
          // let dataArr = [];
          // dataArr=res.data.data;
          let dataArr = [
            {
              name: "我",
              isRoot: true,
              // category: 1,
              symbol: localStorage.getItem("headimgurl"),
            },
          ];
          dataArr = [...dataArr, ...res.data.data.data];
          let linkArr = [];
          dataArr.forEach((item) => {
            item.canClick = true;
            that.allName.push(item.name);
          });
          that.pubdata(dataArr);
          res.data.data.links.forEach((item) => {
            linkArr.push(item);
          });
          setTimeout(function () {
            that.option.series[0].links = linkArr;
            that.option.series[0].data = dataArr;
          }, 300);


        }

        (this.option)
      });
    },
    getMoreData(e) {
      // let that = this;
      // let unionids = [];
      // let currentEvent = e;
      // this.unionidArr.forEach((item) => {
      //   if (item.f_id == currentEvent.data.unionid) {
      //     item.son.forEach((_item) => {
      //       unionids.push(_item.unionid);
      //     });
      //     return;
      //   }
      // });
      // if (!this.canClick) {
      //   return;
      // }
      // this.canClick = false;
      // let data = {
      //   unionid: sessionStorage.getItem("unionid"),
      //   artcId: this.$route.query.activitie_id,
      //   lastUnionid: currentEvent.data.unionid,
      //   target: currentEvent.dataIndex,
      //   size: this.dataSize,
      //   names: this.allName,
      //   unionids: unionids,
      // };

      // this.$fetchPost(URL.getTreeForward.url, data).then((res) => {
      //   let list = [];
      //   //  this.option.series[0].data[currentEvent.data.name].canClick='y'
      //   list = res.data.data;
      //   this.dataSize += list.length;
      //   this.pubdata(list);
      //   this.unionidArr.push({ f_id: currentEvent.data.unionid, son: list });
      //   list.forEach((item) => {
      //     this.option.series[0].data.push(item);
      //     item.canClick = true;
      //     this.allName.push(item.name);
      //   });
      //   this.option.series[0].data.forEach((item) => {
      //     if (item.name == currentEvent.data.name) {
      //       item.canClick = false;
      //     }
      //   });
      //   res.data.links.forEach((item) => {
      //     this.option.series[0].links.push(item);
      //   });
      //   this.canClick = true;
      // });
    },
    getImgData(imgSrc, str) {
      var fun = function (resolve) {
        const canvas = document.createElement("canvas");
        const contex = canvas.getContext("2d");
        const img = new Image();
        img.crossOrigin = "";
        const img_border = new Image();
        if (str) {
          img_border.src = require("./img/border.png");
        } else {
          img_border.src = require("./img/border_2.png");
        }
        img.onload = function () {
          //设置图形宽高比例
          let center = {
            x: img.width / 2,
            y: img.height / 2,
          };
          var diameter = img.width; //半径
          canvas.width = 132;
          canvas.height = 132;
          contex.save();
          contex.beginPath();
          let radius = img.width / 2;
          contex.arc(radius, radius, radius, 0, 2 * Math.PI); //画出圆
          contex.clip(); //裁剪上面的圆形
          contex.drawImage(
            img,
            center.x - radius,
            center.y - radius,
            diameter,
            diameter,
            0,
            0,
            diameter,
            diameter
          ); // 在刚刚裁剪的园上画图
          contex.drawImage(
            img_border,
            center.x - radius,
            center.y - radius,
            diameter,
            diameter,
            0,
            0,
            diameter,
            diameter
          ); // 在刚刚裁剪的园上画图
          // contex.beginPath();
          // contex.arc(20, 90, 20, 0, 2 * Math.PI);
          // contex.stroke();
          // contex.save();

          // }
          contex.restore(); // 还原状态
          resolve(canvas.toDataURL("image/png", 1));
        };
        img.src = imgSrc;
      };
      var promise = new Promise(fun);
      return promise;
    },
    pubdata(json, str) {
      var androidMap = json;
      var picList = []; //获取出全部图片
      for (var i = 0; i < androidMap.length; i++) {
        //把图片路径转成canvas
        let p = this.getImgData(androidMap[i].symbol, androidMap[i].isRoot);
        picList.push(p);
      }

      Promise.all(picList).then(function (images) {
        //取出base64 图片 然后赋值到jsondata中
        for (var i = 0; i < images.length; i++) {
          var img = "image://" + images[i];
          androidMap[i].symbol = img;
        } // 把数据设置到Echart中data
      });
    },
    getDataList() {
      let that = this;
      that
        .$fetchPost(URL.getClueDetails.url, {
          pageNo: that.pageNum,
          activitie_id: this.$route.query.activitie_id,
          tendsType: "FORWARD",
          unionid: localStorage.getItem("unionid"),
          day: this.$route.query.day,
          pageSize: 10,
          openId: sessionStorage.getItem("openId"),
          // openId:that.$store.state.openId
          // activitie_id: "1d0f21a61248483d81d9c35f05ed433e",
          // openId: "oKwLcv7ZrJN9qrwxhR0eqoKuB1yE",
          // pageNo: 1,
          // pageSize: 10,
          // tendsType: "BROWSE"
        })
        .then((res) => {
          if (res.data.code == "20000") {
            let list = res.data.data.list; //请求返回当页的列表
            that.refreshing = false;
            that.loading = false;
            // Toast.clear()
            that.total = res.data.data.total;
            if (list == null || list.length === 0) {
              // 加载结束
              that.finished = true;
              return;
            }
            // 将新数据与老数据进行合并
            if (that.pageNum > 1) {
              that.personList = [...that.personList, ...list];
            } else {
              that.personList = list;
            }
            //如果列表数据条数>=总条数，不再触发滚动加载
            if (that.personList.length >= that.total) {
              that.finished = true;
            }
            // 如果总页数大于当前页码，页码+1
            if (res.data.data.pages > that.pageNum) {
              that.pageNum++;
            }
          }
        });
    },
    onLoad() {
      this.getDataList();
    },
    onRefresh() {
      this.searchValue = "";
      this.pageNum = 1;
      this.finished = false;
      this.getDataList();
    },
    cutString(str, len) {
      //length属性读出来的汉字长度为1
      if (str.length * 2 <= len) {
        return str;
      }
      var strlen = 0;
      var s = "";
      for (var i = 0; i < str.length; i++) {
        s = s + str.charAt(i);
        if (str.charCodeAt(i) > 128) {
          strlen = strlen + 2;
          if (strlen >= len) {
            return s.substring(0, s.length - 1) + "...";
          }
        } else {
          strlen = strlen + 1;
          if (strlen >= len) {
            return s.substring(0, s.length - 2) + "...";
          }
        }
      }
      return s;
    },
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 100%;
  height: 100%;
  background: #f5f5f5;
  /deep/.van-tabs {
    height: 100%;
    .van-tabs__wrap {
      position: fixed;
      width: 100%;
      top: 0;
      left: 0;
      z-index: 9999;
    }
    .van-tabs__content {
      width: 100%;
      height: 100%;
      .van-tab__pane,
      .van-tab__pane-wrapper {
        -webkit-flex-shrink: 0;
        flex-shrink: 0;
        box-sizing: border-box;
        width: 100%;
        height: 100%;
      }
    }
  }

  .shareLink {
    overflow: hidden;
    height: 100%;
    background: url("./img/bg.png") no-repeat;
    background-size: 100%;
    background-position: center center;
  }
  .topLine {
    height: 4px;
    background: #f5f5f5;
    width: 100%;
  }
  .van-pull-refresh {
    width: 100%;
    margin-top: 44px;
    .article_list {
      display: flex;
      flex-wrap: wrap;
      // padding: 0 10px;
      justify-content: space-around;
      .list_item {
        width: 100%;
        padding: 12px 16px;
        margin-bottom: 4px;
        position: relative;
        background: #fff;
        border-radius: 3px;
        .article_pic_wrap {
          .van-image {
            /deep/.van-image__error,
            /deep/ .van-image__img,
            /deep/ .van-image__loading {
              border-radius: 21px;
            }
          }
        }
        .iconBox {
          position: absolute;
          top: 20px;
          left: 85px;
          width: 300px;
          div {
            img {
              width: 12px;
              height: 12px;
            }
            span {
              position: absolute;
              left: 16px;
              font-size: 12px;
              color: #71757a;
              top: 0px;
              margin-top: -2.5px;
            }
          }
          .lightRed {
            font-size: 12px;
            color: #fe6c76;
          }
        }
        .clueNum {
          position: absolute;
          left: 66px;
          bottom: 12px;
          width: 200px;
          display: flex;
          div {
            font-size: 12px;
            color: #646d79;
            line-height: 24px;
            margin-right: 6px;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img {
              display: inline-block;
              width: 13.5px;
              margin-right: 6px;
              margin-bottom: 1px;
            }
          }
          .time {
            img {
              width: 13px;
              height: 13px;
            }
          }
        }
        .infoTipBox {
          position: absolute;
          top: 22px;
          right: 16px;
          font-size: 12px;
          line-height: 26px;
          width: 66px;
          border-radius: 13px;
          background: #ff6927;
          color: #fff;
          font-size: 12px;
          text-align: center;
          span {
            display: inline-block;
            width: 42px;
            height: 20px;
            color: #fff;
          }
          .editBtn {
            display: inline-block;
            width: 42px;
            line-height: 20px;
            color: #fff;
            // background: #ff6927;
            text-align: center;
            // border-radius: 3px;
            position: absolute;
            right: 0;
          }
        }
        .article_pic_wrap {
          position: relative;
          // border-bottom: 1px solid #eaeaea;
          .badge {
            position: absolute;
            bottom: 4px;
            right: 0;
            width: 46px;
            height: 18px;
            line-height: 18px;
            background-color: #5b9bd5;
            color: #fff;
            text-align: center;
            font-size: 12px;
          }
        }
        .article_title {
          // margin-top: 5px;
          font-size: 16px;
          color: #737373;
          position: absolute;
          // width: 55px;
          top: 12px;
          left: 66px;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
          p {
            line-height: 20px;
            color: #3a3a3a;
            .nameSpan {
              max-width: 55px;
              // white-space: nowrap;
              // overflow: hidden;
              // text-overflow: ellipsis;
              // font-style: normal;
              // display: inline-block;
            }
            .statusSpan {
              font-size: 14px;
              color: #71757a;
              display: inline-block;
              img {
                display: inline-block;
                width: 11px;
                height: 11px;
                // vertical-align: middle;
                margin-left: 3px;
              }
            }
          }
        }
      }
    }
    .van-list {
      /deep/ .van-list__error-text,
      /deep/ .van-list__finished-text,
      /deep/ .van-list__loading {
        width: 100%;
      }
    }
  }
}
</style>
